/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

	// Use this variable to set up the common and page specific functions. If you
	// rename this variable, you will also need to rename the namespace below.
	var Sage = {
		// All pages 
		'common': {
			init: function() {
				// JavaScript to be fired on all pages

				// Fix dropdown link
				$('#menu-main-navigation .dropdown > a').on('click', function(){
					location.href = this.href;
				});

				var mq = window.matchMedia('all and (min-width: 768px)');
				if(mq.matches) {
					// the width of browser is more then 768px

					// Show Dropdown on Hover
					$('#menu-main-navigation .dropdown').hover(
						function() {
							$('.dropdown-menu', this).stop( true, true ).fadeIn('fast');
							$(this).toggleClass('open');
						},
						function() {
							$('.dropdown-menu', this).stop( true, true ).fadeOut('fast');
							$(this).toggleClass('open');
						}
					);
				}

				// Social Share buttons
				$('.btn-popup').on('click', function(event){
					event.preventDefault();
					window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=400,width=600');
				});				


				/*
				*  render_map
				*
				*  This function will render a Google Map onto the selected jQuery element
				*
				*  @type	function
				*  @date	8/11/2013
				*  @since	4.3.0
				*
				*  @param	$el (jQuery element)
				*  @return	n/a
				*/


				/*
				*  add_marker
				*
				*  This function will add a marker to the selected Google Map
				*
				*  @type	function
				*  @date	8/11/2013
				*  @since	4.3.0
				*
				*  @param	$marker (jQuery element)
				*  @param	map (Google Map object)
				*  @return	n/a
				*/

				function add_marker( $marker, map ) {
					// var
					var latlng = new google.maps.LatLng( $marker.attr('data-lat'), $marker.attr('data-lng') );

					// create marker
					var marker = new google.maps.Marker({
						position : latlng,
						map : map
					});

					// add to array
					map.markers.push( marker );

					// if marker contains HTML, add it to an infoWindow
					if( $marker.html() ){
						// create info window
						var infowindow = new google.maps.InfoWindow({
							content : $marker.html()
						});

						// show info window when marker is clicked
						google.maps.event.addListener(marker, 'click', function() {
							infowindow.open( map, marker );
						});
					}
				}

				/*
				*  center_map
				*
				*  This function will center the map, showing all markers attached to this map
				*
				*  @type	function
				*  @date	8/11/2013
				*  @since	4.3.0
				*
				*  @param	map (Google Map object)
				*  @return	n/a
				*/

				function center_map( map ) {
					// vars
					var bounds = new google.maps.LatLngBounds();

					// loop through all markers and create bounds
					$.each( map.markers, function( i, marker ){
						var latlng = new google.maps.LatLng( marker.position.lat(), marker.position.lng() );
						bounds.extend( latlng );
					});

					// only 1 marker?
					if( map.markers.length === 1 ){
						// set center of map
					    map.setCenter( bounds.getCenter() );
					    map.setZoom( 16 );
					} else {
						// fit to bounds
						map.fitBounds( bounds );
					}
				}

				function render_map( $el ) {
					// var
					var $markers = $el.find('.marker');

					// vars
					var args = {
						zoom		: 16,
						center		: new google.maps.LatLng(0, 0),
						mapTypeId	: google.maps.MapTypeId.ROADMAP
					};

					// create map	        	
					var map = new google.maps.Map( $el[0], args);

					// add a markers reference
					map.markers = [];

					// add markers
					$markers.each(function(){

				    	add_marker( $(this), map );

					});

					// center map
					center_map( map );
				}


				$('.property-map').each(function(){
					render_map( $(this) );
				});

			},
			finalize: function() {
				// JavaScript to be fired on all pages, after page specific JS is fired
			}
		},
		// Home page
		'home': {
			init: function() {
				// JavaScript to be fired on the home page
				$('.nav-home').affix({
					offset: {
						top: function(){
							return (this.top = $('.home-splash').outerHeight(true) - $('#nav-bar').outerHeight(true));
						}
					}
				});

				$('.home-header-strip').affix({
					offset: {
						// top: 0,
						top: function(){
							return (this.top = $('.home-header-strip').outerHeight(true));
						},
						bottom: function(){
							return (this.bottom = $('.home-splash').outerHeight(true) - $('#nav-bar').outerHeight(true));
						} 
					}
				});

				// Video

				// vars
				var transitionSpeed = 1000;
				var BV = {};

				function showVideo(slideID, videoURI) {
					$currentElem = $('#slide_' + slideID);

					$currentElem.find('.b-home-video-button').on('click', function(event){
						event.preventDefault();
						$(this).fadeOut(1000);

						if(videoURI !== '') {
							$('#home-splash-slider').slick('slickPause');

							BV[slideID] = new $.BigVideo({container: $currentElem});
							BV[slideID].init();
							BV[slideID].show(videoURI,{ambient:false});
						}
					});
				}				

				$('#home-splash-slider').on('init', function(event, slick){
					$currentElem = $('#slide_1');
					videoURI = $currentElem.data('video');

					showVideo(1, videoURI);
				});

				// setup home slider
				$('#home-splash-slider').slick({
					infinite: true,
					dots: true,
					arrows: true,
					speed: transitionSpeed,
					autoplay: false,
					autoplaySpeed: 3500,
					fade: true
				});

				// start autoplay (required to pause it later)
				function startAutoplayTimer() {
					$('#home-splash-slider').slick('slickPlay');
				}
				setTimeout(startAutoplayTimer, transitionSpeed);

				// destroy current video after slide
				$('#home-splash-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
					slideID = currentSlide + 1;
					$currentElem = $('#slide_' + slideID);

					// if( $('#big-video-wrap').length ){
					if( $('.big-video-vid-dimensions').length ){
						BV[slideID].dispose();
						BV = {};
					}

					$currentElem.find('#big-video-wrap').remove();
					$('#home-splash-slider').slick('slickPlay');

				});

				// setup video after slide
				$('#home-splash-slider').on('afterChange', function(event, slick, currentSlide){
					slideID = currentSlide + 1;
					$currentElem = $('#slide_' + slideID);
					videoURI = $currentElem.data('video');

					if (Modernizr.touch) {
						// do nothing
					} else {
						$currentElem.find('.b-home-video-button').show();
					}

					showVideo(slideID, videoURI);
				});

			},
			finalize: function() {
				// JavaScript to be fired on the home page, after the init JS
			}
		},
		// Blog page
		'blog': {
			init: function() {
				// JavaScript to be fired on the about us page

				$('#blog-packery').packery({
					itemSelector: 'article',
					gutter: 30
				});

				$('#blog-cat-select').on('change', function(){
					if( this.options[this.selectedIndex].value === '0' ) {
						location.href = "/blog/";
					} else {
						location.href = "/category/"+this.options[this.selectedIndex].value;
					}
				});

			}
		},

		// Category page
		'archive': {
			init: function() {
				// JavaScript to be fired on the about us page

				$('#blog-packery').packery({
					itemSelector: 'article',
					gutter: 30
				});

				$('#blog-cat-select').on('change', function(){
					if( this.options[this.selectedIndex].value === '0' ) {
						location.href = "/blog/";
					} else {
						location.href = "/category/"+this.options[this.selectedIndex].value;
					}
				});

			}
		},
		// Property results page
		'post_type_archive_listing': {
			init: function() {
				// // Update search
				// $('#b-update-search').on('click', function(event){
				// 	event.preventDefault();
				// 	console.log('Update search!');
				// });

				// // Reset filters
				// $('#b-reset-filters').on('click', function(event){
				// 	event.preventDefault();
				// 	$filterForm = $('#property-filter-form');

				// 	// Uncheck all checkboxes
				// 	$filterForm.find('input[type=checkbox]:checked').prop('checked', false);

				// 	// Clear MLS field
				// 	$filterForm.find('#by-mls').val('');

				// 	// Set price min + max
				// 	$filterForm.find('#price-min option').first().prop('selected', true);
				// 	$filterForm.find('#price-max option').last().prop('selected', true);
				// });
			}
		},
		// Property details page
		'single_listing': {
			init: function() {
				// JavaScript to be fired on the property details page
				var $container = $('#gallery-packery').imagesLoaded(function() {
					// initialize Packery after all images have loaded
					$container.packery({
						itemSelector: '.item' 
					});
				});

				$('#gallery-packery').magnificPopup({
					delegate: 'a',
					type: 'image',
					tLoading: 'Loading image #%curr%...',
					mainClass: 'mfp-img-mobile',
					gallery: {
						enabled: true,
						navigateByImgClick: true,
						preload: [0,1] // Will preload 0 - before current, and 1 after the current image
					},
					image: {
						tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
						// titleSrc: function(item) {
						// 	return item.el.attr('title') + '<small>by MLS</small>';
						// }
					}
				});

				// Video Popup
				$('.property-video a').magnificPopup({type:'iframe'});


				// Affix property tools bar
				$('.property-tools').affix({
					offset: {
						top: function(){
							return (this.top = $('.property-tools').offset().top + $('.property-details').outerHeight(true));
						},
						bottom: function(){
							return (this.bottom = $('footer').outerHeight(true) + $('.awards-logo-strip').outerHeight(true) + 25);
						}
					}
				});


				// Property Tool buttons
				$('#b-calculator').magnificPopup({
					items: {
						src: '#mortgage-calculator',
						type: 'inline'
					}
				});

				$('#b-schedule-showing, #b-schedule-showing-details').magnificPopup({
					items: {
						src: '#schedule-showing',
						type: 'inline'
					}
				});

				$('#b-newsletter').magnificPopup({
					items: {
						src: '#newsletter-signup',
						type: 'inline'
					}
				});
			}
		}
	};

	// The routing fires all common scripts, followed by the page specific scripts.
	// Add additional events for more control over timing e.g. a finalize event
	var UTIL = {
		fire: function(func, funcname, args) {
			var fire;
			var namespace = Sage;
			funcname = (funcname === undefined) ? 'init' : funcname;
			fire = func !== '';
			fire = fire && namespace[func];
			fire = fire && typeof namespace[func][funcname] === 'function';

			if (fire) {
				namespace[func][funcname](args);
			}
		},
		loadEvents: function() {
			// Fire common init JS
			UTIL.fire('common');

			// Fire page-specific init JS, and then finalize JS
			$.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
				UTIL.fire(classnm);
				UTIL.fire(classnm, 'finalize');
			});

			// Fire common finalize JS
			UTIL.fire('common', 'finalize');
		}
	};

	// Load Events
	$(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
